import { FC } from 'react'
import { Path } from 'constants/router'
import { StatusPage } from 'components/common/StatusPage'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * @component
 * 404 Not Found page using the shared StatusPage component.
 * 
 * @example
 * <NotFound />
 */
const NotFound: FC = () => {
  const { t } = useTranslation(['notfound'])
  const navigate = useNavigate()

  return (
    <StatusPage
      title={t('title')}
      description={t('text')}
      primaryButton={{
        text: t('button'),
        onClick: () => navigate(Path.INDEX)
      }}
      secondaryButton={{
        text: t('go_back'),
        onClick: () => navigate(-1)
      }}
    />
  )
}

export default NotFound
